import { getFunctions, httpsCallable, type Functions } from 'firebase/functions'
import { firebaseApp } from './firebase'

// All Cloud Functions live in us-central1 — matches the default
// region configured in the functions/ workspace. Changing it requires
// a coordinated redeploy on both sides.
export const firebaseFunctions: Functions = getFunctions(firebaseApp, 'us-central1')

export interface RedeemInviteInput {
  code: string
  email: string
  password: string
  displayName?: string
}
export interface RedeemInviteOutput {
  uid: string
  customToken: string
}

export interface CreateInviteInput {
  note?: string
  expiresInDays?: number
}
export interface CreateInviteOutput {
  code: string
  id: string
  expiresAt: number | null
}

export interface ListedInviteKey {
  code: string
  status: string
  note: string
  createdAt: number | null
  redeemedAt: number | null
  redeemedBy: string | null
  expiresAt: number | null
}

export const callRedeemInviteKey = httpsCallable<RedeemInviteInput, RedeemInviteOutput>(
  firebaseFunctions,
  'redeemInviteKey'
)

export const callConsumeInviteKeyForCurrentUser = httpsCallable<
  { code: string },
  { ok: true }
>(firebaseFunctions, 'consumeInviteKeyForCurrentUser')

export const callCreateInviteKey = httpsCallable<CreateInviteInput, CreateInviteOutput>(
  firebaseFunctions,
  'createInviteKey'
)

export const callListInviteKeys = httpsCallable<unknown, { keys: ListedInviteKey[] }>(
  firebaseFunctions,
  'listInviteKeys'
)

export const callRevokeInviteKey = httpsCallable<{ code: string }, { ok: true }>(
  firebaseFunctions,
  'revokeInviteKey'
)

export const callRestoreInviteKey = httpsCallable<{ code: string }, { ok: true }>(
  firebaseFunctions,
  'restoreInviteKey'
)

export type InstallerPlatform = 'win' | 'mac' | 'linux'

export interface GetInstallerInput {
  platform: InstallerPlatform
  version?: string
}
export interface GetInstallerOutput {
  url: string
  version: string
  platform: InstallerPlatform
  expiresAt: number
  fileName: string
}

export const callGetInstallerUrl = httpsCallable<GetInstallerInput, GetInstallerOutput>(
  firebaseFunctions,
  'getInstallerUrl'
)
